var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "banned-notice" }, [
        _c("div", { staticClass: "main-c" }, [
          _c("div", {
            staticClass: "content",
            domProps: { innerHTML: _vm._s(_vm.content) },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.handleClose($event)
                },
              },
            },
            [_vm._v("\n            我知道了\n        ")]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }